import { Component } from "react";
import { useHistory } from "react-router-dom";

function FormSuccess(props){
/*class FormSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.props,
    };
  }

  render() {*/
    const { resetState } = props;
    const history = useHistory();

    return (
      <>
        <div className="main-form__success active">
          <div className="main-form__title-block">
            <div className="title title_md">
              Дякуємо, що скористалися нашим сервісом
            </div>
          </div>

          <div className="main-form__content">
            <div className="title title_md-md">
              Ваша заявка прийнята та обробляється
            </div>
            <a
              className="btn btn_dark-blue"
              onClick={(e) => {
                history.push('/investor')
                e.preventDefault();
                resetState();                         
              }}
            >
              <span>ДОБРЕ</span>
            </a>
          </div>
        </div>
      </>
    );
  }
//}

export default FormSuccess;
